import React, {useEffect} from 'react';

export const useThemes = ({backgroundColor, theme}) => {
    useEffect(() => {
        if (theme === "dark") {
            set("explorerColor", "#111216");
            set("cirklon-slider", "#626262");
            set("stepBeatDivision", "#7d7d7d");
            set("editor-bottom", "#1d1f24");
            set("piano-roll-control", "#191919");
            set("baseColor", "black");
            set("dividerColor", "#80808052");
            set("antiColor", "white");
            //set("antiColor", "black");
            set("sidebarColor", "#1d1f24");
            set("sidebarColor2", "#565656");
            set("trackBorderColor", "#1d1f24");
            //set("sidebarColor", "white");
            set("toolbarBackground", "#1d1f24");
            set("sampler-wrapper",  "#191b1fd6");
            set("editorBackground", "#111216");
            //set("editorBackground", "#e4e4e4");
            set("sampleChooser", "#32363c");
            set("sidebar-btn", "#52585c");
            //set("sidebar-btn", "#dbddde");
            set("instrumentChooser", "#353535");
            set("trackInner", "#000000a6");
            set("guideStep", "#252829");
            set("stepColor", "#4a4949");
            set("toolbarButton", "#16151d");
            set("pianoRollRow", "#171717");
            set("pianoRollRowBlack", "#0000008c");
            set("lightInput", "black");
            set("menuBackground", "#424242");
        } else {
            set("explorerColor", "#e1e3e9");
            set("baseColor", "white");
            set("guideStep", "#adafaf");
            set("dividerColor", "#80808052");
            //set("antiColor", "white");
            set("antiColor", "black");
            set("sampler-wrapper",  "#c1c4cad6");
            //set("sidebarColor", "#1d1f24");
            set("sidebarColor", "white");
            set("sidebarColor2", "gray");
            set("toolbarBackground", "#2c2c2c");
            //set("editorBackground", "#111216");
            set("trackBorderColor", "#cbcbcb");
            set("cirklon-slider", "#626262");
            set("editorBackground", backgroundColor);
            set("sampleChooser", "#32363c");
            //set("sidebar-btn", "#52585c");
            set("sidebar-btn", "#dbddde");
            set("piano-roll-control", "#dbddde");
            set("editor-bottom", "#a9a9a9");
            set("instrumentChooser", "#353535");
            set("trackInner", "#0000004d");
            set("stepColor", "#e2e2e2");
            set("stepBeatDivision", "#5e5e5e");
            set("toolbarButton", "#16151d");
            set("pianoRollRow", "white");
            set("pianoRollRowBlack", "#e1e1e1");
            set("lightInput", "white");
            set("menuBackground", "#424242");
        }
    }, [theme, backgroundColor]);

    const set = (property, value) => {
        document.documentElement.style.setProperty('--' + property, value);
    };
};
